module.exports = __webpack_public_path__ + "img/Logo-transparent.0a1239da.png";